import Modal from 'shared/ui/modal';
import { CustomButton } from 'shared/ui/custom-button';
import { useTranslation } from 'react-i18next';

const ModalConfirmUpload = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  name = 'Data',
}) => {
  const { t } = useTranslation('common');

  return (
    <Modal
      title={t('upload_tariff_book')}
      isOpen={isOpen}
      setIsOpen={() => onClose()}
      footer={false}
      closeModal={false}
    >
      <div className="w-[400px]">
        <p className="text-gray-700 text-lg">
          {t('confirm_upload')} <span className="font-extrabold">{name}</span> ?
        </p>
        <div className="w-full flex justify-end text-center mt-6 gap-2">
          <CustomButton
            type="outline"
            size="sm"
            onClick={onClose}
            isLoading={isLoading}
          >
            {t('cancel')}
          </CustomButton>
          <CustomButton
            type="primary"
            size="sm"
            onClick={onConfirm}
            isLoading={isLoading}
          >
            {t('upload')}
          </CustomButton>
        </div>
      </div>
    </Modal>
  );
};

export default ModalConfirmUpload;
